import axios from "axios";
import config from "../config";

export const toggleAdmin = ({
    token,
    teamId,
    teamMemberId
}:
    {
        token: string
        teamId: string
        teamMemberId: string
    }
) => axios.patch(`${config.API_URL}/team-members/${teamMemberId}/admin`, {
    teamId
}, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})